let routes = [
  //产品功能
  {
    path: '/productFeatures',
    name: 'productFeatures',
    component: () => import('@/views/productFeatures/index.vue')
  }
]

export default routes
